import { render, staticRenderFns } from "./SubcontractsList.vue?vue&type=template&id=53d5046c"
import script from "./SubcontractsList.vue?vue&type=script&lang=js"
export * from "./SubcontractsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports